export const CYCLES_CLIENT_DB_EXPIRATION_TIMEOUT_SEC = 24 * 60 * 60; // 24 hours

export const CYCLES_LOAD_LIMIT = 5;
